export const AUTHENTICATING_USER = "AUTHENTICATING_USER";
export const FETCHING_USERS = "FETCHING_USERS";
export const FETCHING_ONE_USER = "FETCHING_ONE_USER";
export const CREATING_USER = "CREATING_USER";
export const CREATING_PASSWORD = "CREATING_PASSWORD";
export const RESETTING_PASSWORD = "RESETTING_PASSWORD";
export const UPDATE_ONE_USER = "UPDATE_ONE_USER";
export const UPDATING_USER_IMAGE = "UPDATING_USER_IMAGE";
